<template>
  <div :class="classModifiers">
    <div class="market-detail-charts__content-loader" v-show="!isComponentReady">
      <market-chart-loader></market-chart-loader>
    </div>
    <div v-show="isComponentReady">
      <div class="market-detail-charts__timeline">
        <charts-timeline
          :market="market"
          :chartOptions="chartOptions"
          :isChartLoading="isLoading"
          :showVolume="showVolume"
          :showPriceAxisZoom="showPriceAxisZoom"
          @timelineChange="onTimelineChange"
          @typeChange="onTypeChange"
          @volumeChartToggle="volumeChartToggle"
          @priceAxisZoomToggle="priceAxisZoomToggle"
        >
        </charts-timeline>
      </div>

      <div class="market-detail-charts__body" ref="chartLoadingScope">
        <template v-if="!showStats">
          <div v-if="title" class="market-detail-charts__title" v-html="title"></div>
          <charts-container
            :market="market"
            :timeline="chartTimeline"
            :chartOptions="chartOptions"
            :showVolume="showVolume"
            :showPriceAxisZoom="showPriceAxisZoom"
            :chartType="chartType"
            :chartData="filteredChartData"
            :chartDataLoaded="chartDataLoaded"
            :chartSystemOptions="chartSystemOptions"
          ></charts-container>
          <charts-table
            class="market-detail-charts__table"
            v-if="showChartsTable"
            :chartOptions="chartOptions"
            :contracts="chartContracts"
            @toggleItem="onContractToggle"
          ></charts-table>
          <div class="market-detail-charts__caption" v-if="caption" v-html="caption"></div>
        </template>
        <template v-else>
          <div class="market-detail-charts__stats-container">
            <market-contracts-stats
              v-if="marketContractsStats.length > 0"
              :isFixed="hasMarketHiddenContracts(market)"
              :stats="marketContractsStats"
            ></market-contracts-stats>
            <div class="market-detail-charts__stats-no-data" v-else-if="!isLoading">
              No data to display
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script src="./market-detail-charts.js"></script>
<style src="./market-detail-charts.scss" lang="scss"></style>
